"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Locked = _interopRequireDefault(require("@insided/destination/icons/Locked"));

var _ClockDestination = _interopRequireDefault(require("@insided/destination/icons/ClockDestination"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var PrivateGroupPlaceholder = function PrivateGroupPlaceholder(_ref) {
  var isLoading = _ref.isLoading,
      onRequest = _ref.onRequest,
      requestPending = _ref.requestPending;
  return (0, _preact.h)("div", {
    className: "group-private__placeholder"
  }, (0, _preact.h)("div", {
    className: "group-content-container"
  }, !requestPending && (0, _preact.h)("div", null, (0, _preact.h)(_Locked.default, {
    className: "icon-locked"
  }), (0, _preact.h)("h2", null, (0, _preact.h)("span", {
    dangerouslySetInnerHTML: {
      __html: (0, _translations.t)('Forum', 'groups.request.to.join.private.group')
    }
  })), (0, _preact.h)("div", {
    className: "group-private__call-to-action"
  }, (0, _preact.h)(_Button.default, {
    type: "button",
    className: "btn--cta btn",
    isLoading: isLoading,
    onClick: onRequest,
    oldStyle: true
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.request.to.join"
  })))), requestPending && (0, _preact.h)("div", null, (0, _preact.h)(_ClockDestination.default, {
    className: "icon-clockDestination"
  }), (0, _preact.h)("h2", null, (0, _preact.h)(_phrase.default, {
    p: "groups.request.is.sent"
  })))));
};

var _default = PrivateGroupPlaceholder;
exports.default = _default;